import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import { useTranslation } from "react-i18next";

interface UrlLengthAlertDialogProps {
  open: boolean;
  onClose: () => void;
}

const UrlLengthAlertDialog = ({ open, onClose }: UrlLengthAlertDialogProps) => {
  const { t } = useTranslation(["virtual-editions-page", "common"]);

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{t("warning", { ns: "common" })}</DialogTitle>
      <DialogContent>{t("length-error")}</DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t("backButton", { ns: "common" })}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default UrlLengthAlertDialog;
